export enum QuestionnaireType {
  QUESTIONNAIRE_SURVEY = 'QUESTIONNAIRE_SURVEY',
  QUESTIONNAIRE_EXAMINATION = 'QUESTIONNAIRE_EXAMINATION',
  QUESTIONNAIRE_ASSESSMENT = 'QUESTIONNAIRE_ASSESSMENT',
}
